var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var StoryState_1;
import { State, Action, Selector, Store } from '@ngxs/store';
import { StoryStateModel } from './story.state.model';
import { FetchStory, LoadStorySuccess, SynchronizeChapters, ResetStory, LoadStoryChunk, SetIncomingStory, LoadStory, BuildStory, UnloadStory, SetStoryText, SetStory, SetStoryId, LoadStoryChunkSuccess, LoadStoryFail, ImportStory, ReorderLoadChunks, ImportStorySuccess } from './story.actions';
import { StoryService } from '../story.service';
import { SetChapter, SetChapters, SelectChapter, RegisterChapterThumbnails } from './chapters/story.chapters.actions';
import { StoryChaptersState } from './chapters/story.chapters.state';
import { SetLabels } from './labels/story.labels.actions';
import { StoryLoadTypeEnum } from '../models/story-load-type.enum';
import { mergeModules } from '../merge/merge-modules';
import { Thumbnail } from 'src/app/shared/thumbnail-utils';
import { environment } from 'src/environments/environment';
import { SerializeModuleService } from 'src/app/edit/serialize-module.service';
import { TrimConfiguration } from 'src/app/edit/models/trim-config.model';
import { partition } from 'lodash';
const ɵ0 = undefined;
const initialState = {
    loading: false,
    incoming: {
        id: ɵ0,
        type: undefined
    },
    storyId: undefined,
    storyType: undefined,
    loadingChunk: null,
    loadType: StoryLoadTypeEnum.OnDemand,
    loadChunks: [],
    loadChunksRemaining: [],
    thumbnailLookup: []
};
let StoryState = StoryState_1 = class StoryState {
    constructor(store, storyService, serializeModuleService) {
        this.store = store;
        this.storyService = storyService;
        this.serializeModuleService = serializeModuleService;
    }
    /**
     * Selectors
     */
    static getStory(state) {
        return state.story;
    }
    static getStoryId(state) {
        return state.storyId;
    }
    static getLoadChunks(state) {
        return state.loadChunks;
    }
    static getLoadChunksRemaining(state) {
        return state.loadChunksRemaining;
    }
    static getStoryInfo(state) {
        return {
            id: state.storyId,
            type: state.storyType
        };
    }
    static getLoadType(state) {
        return state.loadType;
    }
    static getIncomingStoryInfo(state) {
        return state.incoming;
    }
    /**
     *
     * Actions
     */
    setStoryText(context, action) {
        const story = context.getState().story;
        if (story) {
            context.patchState({
                story: Object.assign({}, story, { displayName: action.displayName })
            });
        }
    }
    setStory(context, action) {
        context.patchState({
            story: action.story
        });
    }
    SetStoryId(context, action) {
        context.patchState({
            storyId: action.id
        });
    }
    setIncomingStory(context, action) {
        const state = context.getState();
        const { id, type, reset } = action;
        if (id !== state.storyId || reset) {
            context.patchState({
                incoming: { id: id, type: type }
            });
        }
        else if (reset) {
            context.dispatch(new BuildStory(action.id, state.story, action.type, state.loadType));
        }
    }
    // load the entire incoming story and its assets
    loadStory(context, action) {
        this.storyService.getStory(action.id, action.type, action.lang)
            .subscribe(
        // success
        (story) => {
            context.dispatch(new LoadStorySuccess(story, action.id, action.type));
        }, 
        // error
        () => {
            context.dispatch(new LoadStoryFail(action.id, action.type));
        });
    }
    // fetch the story JSON from BD servers and patch state with app formatted story
    // #NOTE: [EM] - fetch->build->load baked into this function. Assumes you'll only have a single story loaded
    fetchStory(context, action) {
        this.storyService.getStory(action.id, action.type, action.lang)
            .subscribe(
        // success
        (story) => {
            context.dispatch(new LoadStorySuccess(story, action.id, action.type));
        }, 
        // error
        () => {
            context.dispatch(new LoadStoryFail(action.id, action.type));
        });
    }
    // Put story into engine and kickoff asset loading. 
    // #TODO: [EM] This should be renamed because it's primary job is to unload before continuing load
    loadStorySuccess(context, action) {
        // #TODO: [MR] - Discuss with Evan. unloadStory(null) was the previous value, and we depended on Human.
        // Get last story ID from state. This will be overwritten later on Human.modules.modules for the right id.
        const { storyId, loadType } = context.getState();
        this.storyService.unloadStory(null).subscribe(() => {
            context.dispatch(new BuildStory(action.id, action.story, action.type, loadType));
        });
    }
    buildStoryWorkflow(context, storyId, story, storyType, loadType, targetChapterIdx = 0, thumbnails = new Map()) {
        this.storyService.buildStory(storyId, story, true).subscribe(built => {
            // parse chapters from Human Engine
            const chapters = this.storyService.getStoryChapters(storyId, storyType);
            // parse labels
            let labels = [];
            chapters.forEach((chapter) => {
                labels = [...labels, ...chapter.labels];
            });
            const config = this.storyService.getLoadConfig(storyId, targetChapterIdx);
            const loadChunks = this.storyService.getStoryLoadChunks(storyId, config, loadType);
            // patch story state
            context.patchState({
                storyId,
                story,
                loadChunks,
                loadChunksRemaining: loadChunks,
                incoming: { id: undefined, type: undefined }
            });
            // patch story-chapters state with chapters
            context.dispatch(new SetChapters(chapters));
            context.dispatch(new RegisterChapterThumbnails(thumbnails));
            context.dispatch(new SetLabels(labels));
            context.dispatch(new SelectChapter(chapters[targetChapterIdx]));
            // kick off loading
            context.dispatch(new LoadStoryChunk());
        });
    }
    // I need an entry point to this. Ask Mike
    importStorySuccess(context, action) {
        const state = context.getState();
        const storyType = state.storyType;
        const storyId = state.storyId;
        const loadType = StoryLoadTypeEnum.Progressive;
        const serializeInPlace = true;
        const namespaceMap = {};
        const trimConfig = new TrimConfiguration();
        const replaceObjectId = false;
        const story = this.store.selectSnapshot(StoryState_1.getStory);
        const chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
        const currentStory = this.serializeModuleService.serialize(serializeInPlace, namespaceMap, trimConfig, replaceObjectId, story, chapters).story;
        const newStory = mergeModules(currentStory, storyId, action.story, action.id, environment.exportType);
        // when a new module is imported, its thumbnails reference the origin module and chapters
        // we need a look up table to know where to get thumbnails before we save the module to a bookmark.
        // here we build the lookup table, and read it in Thumbnail.generateThumbnailUrls
        const originalThumbnails = currentStory.chapters.map((chapter, i) => {
            const newChapterId = chapter.id;
            const originalChapterId = chapter.id;
            const originalStoryId = storyId;
            return { newChapterId, originalChapterId, originalStoryId };
        });
        const thumbnailLookup = (state.thumbnailLookup || [])
            .concat(action.story.chapters.map((chapter, i) => {
            const startIndex = currentStory.chapters.length;
            const newChapterId = newStory.chapters[startIndex + i].id;
            const originalChapterId = chapter.id;
            const originalStoryId = action.id;
            return { newChapterId, originalChapterId, originalStoryId };
        }));
        context.patchState({
            thumbnailLookup
        });
        const thumbnails = Thumbnail.generateThumbnailUrls([...originalThumbnails, ...thumbnailLookup]);
        // merge any thumbnails that currently live in state that are a blob
        const prevThumbnails = this.store.selectSnapshot(StoryChaptersState.getRegisteredThumbnails);
        const blobThumbnails = new Map([...prevThumbnails].filter(entry => entry[1].snapshot));
        const newThumbnails = new Map([...thumbnails, ...blobThumbnails]);
        // a story must be unloaded before it is rebuilt
        // we need to flush the engine's definition of the scene graph, because we made a new one in combineModules
        const purgeAssets = true; // we need to purge assets until parsing animations has been decoupled from fetching from the server
        this.storyService.unloadStory(null, purgeAssets).subscribe(() => {
            this.buildStoryWorkflow(context, storyId, newStory, storyType, loadType, newStory.chapters.length - 1, newThumbnails);
        });
    }
    // Build story from story data. 
    buildStory(context, action) {
        // build and activate story into Human Engine
        const thumbnailLookup = action.story.chapters.map((chapter, i) => {
            const newChapterId = chapter.id;
            const originalChapterId = chapter.id;
            const originalStoryId = action.id;
            return { newChapterId, originalChapterId, originalStoryId };
        });
        const thumbnails = Thumbnail.generateThumbnailUrls(thumbnailLookup);
        const targetChapterIdx = action.chapterIdx || 0;
        this.buildStoryWorkflow(context, action.id, action.story, action.type, action.loadType, targetChapterIdx, thumbnails);
    }
    // #TODO: [EM] more granular control of life cycle needed.
    unloadStory() { }
    loadStoryChunk(context) {
        // assume the chunk to load is in the zeroth index of loadChunksRemaining
        const chunkToLoad = context.getState().loadChunksRemaining[0];
        if (!chunkToLoad) {
            return;
        }
        // update the queue of remaining chunks.
        context.patchState({
            loadingChunk: chunkToLoad
        });
        // load assets through story Service
        // then, dispatch success and continue loading chunks
        this.storyService.loadStoryChunk(chunkToLoad, () => {
            context.dispatch([
                new LoadStoryChunkSuccess(chunkToLoad),
                new LoadStoryChunk()
            ]);
        });
    }
    /**
     * Reorder load chunks, so that the currently selected chapter's chunks are next in the queue.
     * This does not interrupt any currently loading chunks.
     */
    reorderLoadChunks(context, action) {
        const { loadChunksRemaining } = context.getState();
        const [chunksForActiveChapter, otherChunks] = partition(loadChunksRemaining, chunk => chunk.chapterId === action.chapterId);
        context.patchState({
            loadChunksRemaining: [...chunksForActiveChapter, ...otherChunks]
        });
    }
    loadStoryChunkSuccess(context, action) {
        const chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
        const chapter = Object.assign({}, chapters.find((_chapter) => action.chunk.chapterId === _chapter.id));
        const loadChunksRemaining = context
            .getState()
            .loadChunksRemaining.filter(chunk => chunk.chunkId !== action.chunk.chunkId);
        context.patchState({
            loadingChunk: null,
            loadChunksRemaining
        });
        // merge per-chapter ready state with chunk readyState
        chapter.readyState = Object.assign({}, chapter.readyState, action.chunk.readyState);
        context.dispatch(new SetChapter(chapter));
    }
    synchronizeChapters(context) {
        const chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
        const { story } = context.getState();
        context.patchState({
            story: Object.assign({}, story, { chapters: [...chapters] })
        });
    }
    importStory(context, action) {
        this.storyService.getStory(action.id, action.type, action.lang)
            .subscribe(
        // success
        (story) => {
            context.dispatch(new ImportStorySuccess(story, action.id, action.type));
        });
    }
    resetStory(context) {
        context.setState(initialState);
    }
};
__decorate([
    Action(SetStoryText),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetStoryText]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "setStoryText", null);
__decorate([
    Action(SetStory),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetStory]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "setStory", null);
__decorate([
    Action(SetStoryId),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetStoryId]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "SetStoryId", null);
__decorate([
    Action(SetIncomingStory),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetIncomingStory]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "setIncomingStory", null);
__decorate([
    Action(LoadStory),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, LoadStory]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "loadStory", null);
__decorate([
    Action(FetchStory),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, FetchStory]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "fetchStory", null);
__decorate([
    Action(LoadStorySuccess),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, LoadStorySuccess]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "loadStorySuccess", null);
__decorate([
    Action(ImportStorySuccess),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ImportStorySuccess]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "importStorySuccess", null);
__decorate([
    Action(BuildStory),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, BuildStory]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "buildStory", null);
__decorate([
    Action(UnloadStory),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "unloadStory", null);
__decorate([
    Action(LoadStoryChunk),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "loadStoryChunk", null);
__decorate([
    Action(ReorderLoadChunks),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ReorderLoadChunks]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "reorderLoadChunks", null);
__decorate([
    Action(LoadStoryChunkSuccess),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, LoadStoryChunkSuccess]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "loadStoryChunkSuccess", null);
__decorate([
    Action(SynchronizeChapters),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "synchronizeChapters", null);
__decorate([
    Action(ImportStory),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ImportStory]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "importStory", null);
__decorate([
    Action(ResetStory),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], StoryState.prototype, "resetStory", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryStateModel]),
    __metadata("design:returntype", void 0)
], StoryState, "getStory", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryStateModel]),
    __metadata("design:returntype", void 0)
], StoryState, "getStoryId", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryStateModel]),
    __metadata("design:returntype", void 0)
], StoryState, "getLoadChunks", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryStateModel]),
    __metadata("design:returntype", void 0)
], StoryState, "getLoadChunksRemaining", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryStateModel]),
    __metadata("design:returntype", void 0)
], StoryState, "getStoryInfo", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryStateModel]),
    __metadata("design:returntype", void 0)
], StoryState, "getLoadType", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryStateModel]),
    __metadata("design:returntype", void 0)
], StoryState, "getIncomingStoryInfo", null);
StoryState = StoryState_1 = __decorate([
    State({
        name: 'story',
        defaults: initialState
    }),
    __metadata("design:paramtypes", [Store,
        StoryService,
        SerializeModuleService])
], StoryState);
export { StoryState };
export { ɵ0 };
